export enum HelpdeskTemplateDtoKeysEnum {
  PROJECT_TEMPLATE_ALL_QUERY_DTO = 'helpdesk/helpdesk.template.all.query.dto',
  AVAILABLE_PARENTS_SEARCH_DTO = 'helpdesk/helpdesk.template.available.parents.search.dto',
  HELPDESK_TASK_TEMPLATE_FORM_DTO = 'helpdesk/helpdesk.template.form.dto',
  HELPDESK_TASK_TEMPLATE_LIST_QUERY_DTO = 'helpdesk/helpdesk.template.list.query.dto',
}
